// extracted by mini-css-extract-plugin
export default {"panel":"BpCVBibrJuGM4R0NXXn1","panelHeader":"e1e_RwF4DXxLuN3nFr8t","actions":"TAhJz7CPrlmIVEJjVm2r","description":"ueT799wv76qlEoPKjXCK"};